import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { App } from './app/app'
import 'zone.js'
import { environment } from './environments/environment'

if (!environment.apiUrl) {
  throw new Error('API URL not configured!')
}

bootstrapApplication(App, appConfig).catch((err) => {
  if (environment.features.enableLogging) console.error('Bootstrap failed:', err)
})

if (environment.features.enableLogging) {
  console.log(`🚀 App running in ${environment.environmentName} mode`)
}
